import { cloneElement, type ReactElement, type ReactNode } from "react";
import { ACTIVE_ROW_CLASSES } from "./SidebarSpaceRow";

/** A top-level row in the sidebar: an icon and a label. */
export function NavRow({
  icon,
  active,
  onClick,
  expanded,
  children,
}: Readonly<{
  icon: ReactElement<{ size?: number }>;
  active?: boolean;
  onClick: () => void;
  /** For a row that opens a panel: sets `aria-expanded` and marks it as opening a dialog. */
  expanded?: boolean;
  children: ReactNode;
}>) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-expanded={expanded}
      aria-haspopup={expanded === undefined ? undefined : "dialog"}
      className={[
        "flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2 text-left transition-colors btn-focus-ring",
        "[font:var(--type-body-xs)]",
        active
          ? `${ACTIVE_ROW_CLASSES} ![font-weight:var(--weight-medium)] text-content-primary`
          : "text-content-secondary hover:bg-surface-base hover:text-content-primary",
      ].join(" ")}
    >
      {cloneElement(icon, { size: 17 })}
      <span className="min-w-0 flex-1 truncate">{children}</span>
    </button>
  );
}
